import { USE_MOCKS } from '../config/serviceConfig';
import { createUserMock } from './mock/user.mock';
import { userReal } from './real/user.real';
import type { IUserService } from './interfaces/IUserService';

// In modalità mock serve l'userId per trovare l'utente corretto
export const createUserService = (userId?: string): IUserService => {
  if (USE_MOCKS) return createUserMock(userId ?? '');
  return userReal;
};
